export enum OrganizationType {
    MAIN = 'MAIN',
    STAKEHLDR = 'STAKEHLDR',
    ORG_UNIT = 'ORG_UNIT'
}
